/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import { setSelectedReceivingType } from 'store/ducks/sellingTerminals/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import CONST_SELLING_POINTS from 'constants/sellingPoints';

// Styles
import useStyles from './receivingTypeFilter.styles';

const ReceivingTypeFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const filteredReceivingType = useSelector(
    (state: ApplicationState) => state.sellingTerminals.selectedReceivingType,
  );

  const handleType = (type: number) => {
    dispatch(
      setSelectedReceivingType({
        selectedReceivingType: type,
      }),
    );
  };

  return (
    <List dense>
      {CONST_SELLING_POINTS.TRANSACTION_TYPES.map(({ KEY, VALUE }) => (
        <ListItem key={KEY} button>
          <ListItemText
            id={VALUE}
            primary={VALUE}
            onClick={() => handleType(KEY)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Radio
              edge='end'
              name={VALUE}
              color='primary'
              onClick={() => handleType(KEY)}
              checked={filteredReceivingType === KEY}
              inputProps={{ 'aria-labelledby': VALUE }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { ReceivingTypeFilter };
export default ReceivingTypeFilter;
